import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ISingInResponse } from '../../services/singnin.service';

export interface ISingIn {
  identity: ISingInResponse;
  auth: {
    oya_oyana_access_token: string;
    expiredToken: boolean;
  };
}

const initialState: ISingIn = {
  identity: {
    oyanaid: '',
    email: '',
    whatsapp: ''
  },
  auth: {
    oya_oyana_access_token: '',
    expiredToken: false
  }
};

export const singIn = createSlice({
  name: 'singin',
  initialState,
  reducers: {
    saveOyanaIdentity: (state, action: PayloadAction<ISingInResponse>) => {
      state.identity = action.payload;
    },
    saveOyanaAuth: (state, action: PayloadAction<string>) => {
      state.auth.oya_oyana_access_token = action.payload;
    },
    expireAuth: (state, action) => {
      state.auth.expiredToken = action.payload;
    }
  }
});

export const { saveOyanaIdentity, saveOyanaAuth, expireAuth } = singIn.actions;
export const singInReducer = singIn.reducer;
